var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimesFull(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    fill: "currentColor",
    "aria-hidden": "true"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.36 9.7a.75.75 0 10-1.06-1.06l-2.3 2.3-2.3-2.3A.75.75 0 008.64 9.7l2.3 2.3-2.3 2.3a.75.75 0 001.06 1.06l2.3-2.3 2.3 2.3a.75.75 0 001.06-1.06l-2.3-2.3 2.3-2.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.25a10.75 10.75 0 100 21.5 10.75 10.75 0 000-21.5zM2.75 12a9.25 9.25 0 1118.5 0 9.25 9.25 0 01-18.5 0z"
  })));
}
export default SvgTimesFull;